import { FrontPage } from '../../types/optimizely/frontpage';
import { MainContentAreaExpandedValue } from '../../types/optimizely';
import { isBenefitsListBlock } from '../../types/optimizely/blocks/benefitsListBlock';
import { BenefitsListBlock } from '../BenefitsListBlock/BenefitsListBlock';
import { isTextImageBlockData } from '../../types/optimizely/blocks/textImageBlock';
import { TextImageBlockContainter } from '../TextImageBlock/TextImageBlock';
import { isAccordionBlock } from '../../types/optimizely/blocks/accordionBlock';
import { isEasyStepsBlock } from '../../types/optimizely/blocks/easyStepsBlock';
import { EasyStepsBlock } from '../EasyStepsBlock/EasyStepsBlock';
import { StickyNavigation } from '../StickyNavigation/StickyNavigation';
import React from 'react';
import { AccordionBlock } from '../AccordionBlock/AccordionBlock';

const generateModule = (
	module: MainContentAreaExpandedValue,
	isHeroBlock?: boolean,
) => {
	if (!module.contentType) {
		return null;
	}

	if (isBenefitsListBlock(module)) {
		return <BenefitsListBlock {...module} />;
	}

	if (isTextImageBlockData(module)) {
		return <TextImageBlockContainter {...module} isHeroBlock={isHeroBlock} />;
	}

	if (isEasyStepsBlock(module)) {
		return <EasyStepsBlock {...module} />;
	}

	if (isAccordionBlock(module)) {
		return <AccordionBlock {...module} />;
	}
};

export const Module = ({ content }: { content: FrontPage | null }) => {
	if (!content) {
		return null;
	}

	return (
		<>
			{generateModule(content.heroBlock.expandedValue, true)}
			<StickyNavigation content={content} />
			{content.mainContentArea.expandedValue.map((module, index) => (
				<React.Fragment key={index}>{generateModule(module)}</React.Fragment>
			))}
		</>
	);
};
